
const redirectionRoutes = {
	// Authentication
	login: {
		name: 'Login',
		path: `/login`,
	},
	forgotPassword: {
		name: 'Admin Forgot Passowrd',
		path: `/forgot-password`,
	},
	resetPasswordWithToken: {
		name: 'Admin Reset Passowrd',
		path: `/reset-password/:token`,
	},
	resetPasswordWithoutToken: {
		name: 'Admin Reset Passowrd',
		path: `/reset-password`,
	},
	twoFactorAuthentication: {
		name: 'Multi Factor Authentication',
		path: `/two-factor-authentication`,
	},
	TOTPAuthentication: {
		name: 'Multi Factor Authentication',
		path: `/totp-otp-authentication`,
	},
	TOTPSetup: {
		name: 'TOTP Setup',
		path: `/totp-setup`,
	},
	createAccount: {
		name: 'Create Account',
		path: `/create-account`,
	},
	setupPassword: {
		name: 'Setup Password',
		path: `/setup-password`,
	},
	verifyAccountWithToken: {
		name: 'Verify Account With Token',
		path: `/verify-account/:token`,
	},
	verifyAccountWithoutToken: {
		name: 'Verify Account Without Token',
		path: `/verify-account`,
	},
	loginAs:{
		name: 'Login As',
		path: `/login-as`,		
	},

	// Dashboard
	dashboard: {
		name: 'Dashboard',
		path: `/dashboard`,
	},
	// Sites
	sites: {
		name: 'Sites',
		path: `/sites`,
	},
	// Scan
	scan: {
		name: 'Scan',
		path: `/scan`,
	},
	// Scan History
	scanHistory: {
		name: 'Scan History',
		path: `/scan-history`,
	},
	// Users
	users: {
		name: 'Users',
		path: `/users`,
	},
	// Payment
	payment: {
		name: 'Payment',
		path: `/payment`,
	},
	paymentSuccess: {
		name: 'Payment Success',
		path: `success`,
	},
	// Roles
	roles: {
		name: 'Roles',
		path: `/roles-permission`,
	},
	// Subscription
	subscription: {
		name: 'Subscription',
		path: `/subscription`,
	},
	// Profile
	profile: {
		name: 'Profile',
		path: `/profile`,
	},
	// Change Password
	changePassword: {
		name: 'Change Password',
		path: `/change-password`,
	},
	// Branding
	branding: {
		name: 'Branding',
		path: `/branding`,
	},

	// Common Add Edit View
	commonAdd: {
		name: 'Add',
		path: `add`,
	},
	commonEdit: {
		name: 'Edit',
		path: `edit/:id`,
	},
	commonView: {
		name: 'View',
		path: `view/:id`,
	},

	
	// Logout
	logout: {
		name: 'Logout',
		path: `/logout`,
	},
	// Page Not Found
	pageNotFound: {
		name: 'Page Not Found',
		path: `*`,
	},

	help: {
		name: 'Help',
		path: `/help`,
	},
	// Request LOA
	requestLoa: {
		name: 'Request LOA',
		path: `/request-loa`,
	},
	// Account Settings
	accountSettings: {
		name: 'Account Settings',
		path: `/account-settings`,
	},
	scanOTPRequest: {
		name: 'Scan OTP Request',
		path: `/scan-otp-request`,
	},
	apiIntegration: {
		name: 'API Integration',
		path: `/api-integration`,
	},
}

export { redirectionRoutes };
